// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
  width: 100%;
  position: relative;
}

.leaflet {
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 1;
}

.custom-popup .leaflet-popup-content-wrapper {
  background: #2c3e50;
  color: #fff;
  font-size: var(--font-size-small);
  line-height: var(--spacing-large);
  border-radius: 0;
}

.custom-popup .leaflet-popup-content-wrapper a {
  color: rgba(255, 255, 255, 0.1);
}

.custom-popup .leaflet-popup-tip-container {
  width: 30px;
  height: 15px;
}

.custom-popup .leaflet-popup-tip {
  background: transparent;
  border: none;
  box-shadow: none;
}

::ng-deep .leaflet-tooltip.track-tooltip {
  width: 200px;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.4;
  padding: 6px 10px;
}

ion-fab-button ion-icon {
  font-size: var(--icon-size-small);
}

.map-layers-fab,
.center-fab,
.opacity-fab,
.location-fab,
.globe-fab,
.windy-fab {
  position: absolute;
  z-index: 999;
}

.map-layers-fab {
  top: 10px;
  right: 10px;
}

.opacity-container {
  position: absolute;
  padding: 0;
  margin: 0;
  background-color: var(--color-primary-pale);
  z-index: 999;
}

.icon-contrast {
  color: var(--color-primary-contrast-contrast);
}

.opacity-item {
  justify-content: space-around;
  justify-items: center;
  position: absolute;
  border-radius: var(--border-radius-large);
  z-index: 999;
  opacity: 0.7;
  width: 100%;
  --padding-inline: var(--spacing-small);
  --inner-padding-end: var(--spacing-medium);
}
.opacity-item::part(native) {
  --padding-start: var(--spacing-small);
}
.opacity-item ion-icon[slot=start] {
  margin: var(--spacing-small);
  font-size: var(--icon-size-small);
}
.opacity-item ion-range {
  padding-inline: var(--spacing-small) var(--spacing-medium);
}

.location-container {
  position: absolute;
  padding: 0;
  margin: 0;
  z-index: 999;
}

.location-searchbar {
  z-index: 999;
  --padding: 0;
  --background: white;
}

.location-list {
  position: absolute;
  overflow-y: auto;
  border-radius: 0 0 8px 8px;
  z-index: 999;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.location-list::-webkit-scrollbar {
  display: none;
}

.location-item:hover {
  --background: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.location-item:active {
  --background: rgba(0, 0, 0, 0.12);
}

/* Small screens */
@media (max-width: 599px) {
  ion-fab-button {
    height: 36px;
    width: 36px;
  }
  app-map-layers-panel {
    --map-panel-offset-top: 54px;
    --map-panel-offset-right: 10px;
  }
  .center-fab {
    top: 10px;
    right: 50px;
  }
  .opacity-fab {
    top: 10px;
    right: 90px;
  }
  .location-fab {
    top: 10px;
    right: 130px;
  }
  :host.no-center-fab .opacity-fab {
    right: 50px;
  }
  :host.no-center-fab .location-fab {
    right: 90px;
  }
  .globe-fab {
    top: 10px;
    left: 10px;
  }
  .windy-fab {
    top: 50px;
    right: 10px;
  }
  .opacity-container {
    --min-height: 30px;
    width: 116px;
    top: 50px;
    right: 12px;
  }
  .location-container {
    --min-height: 30px;
    width: 175px;
    top: 35px;
    right: 0;
  }
  .opacity-item {
    --min-height: 30px;
  }
  .opacity-item ion-range {
    --height: 30px;
  }
  .location-list {
    max-height: 150px;
    width: 151px;
    top: 45px;
    right: 12px;
  }
  .location-item {
    --min-height: 30px;
    font-size: 10px;
  }
}
/* Medium screens */
@media (min-width: 600px) and (max-width: 1023px) {
  ion-fab-button {
    height: 44px;
    width: 44px;
  }
  app-map-layers-panel {
    --map-panel-offset-top: 62px;
    --map-panel-offset-right: 10px;
  }
  .center-fab {
    top: 10px;
    right: 60px;
  }
  .opacity-fab {
    top: 10px;
    right: 110px;
  }
  .location-fab {
    top: 10px;
    right: 160px;
  }
  :host.no-center-fab .opacity-fab {
    right: 60px;
  }
  :host.no-center-fab .location-fab {
    right: 110px;
  }
  .globe-fab {
    top: 10px;
    left: 10px;
  }
  .windy-fab {
    top: 60px;
    right: 10px;
  }
  .opacity-container {
    --min-height: 36px;
    width: 130px;
    top: 60px;
    right: 15px;
  }
  .location-container {
    --min-height: 36px;
    width: 215px;
    top: 45px;
    right: 0;
  }
  .opacity-item {
    --min-height: 36px;
  }
  .opacity-item ion-range {
    --height: 36px;
  }
  .location-list {
    max-height: 200px;
    width: 191px;
    top: 48px;
    right: 12px;
  }
  .location-item {
    --min-height: 40px;
    font-size: 12px;
  }
}
/* Large screens */
/* Large screens */
@media (min-width: 1024px) {
  ion-fab-button {
    height: 50px;
    width: 50px;
  }
  app-map-layers-panel {
    --map-panel-offset-top: 68px;
    --map-panel-offset-right: 10px;
  }
  .center-fab {
    top: 10px;
    right: 70px;
  }
  .opacity-fab {
    top: 10px;
    right: 130px;
  }
  .location-fab {
    top: 10px;
    right: 190px;
  }
  .opacity-container {
    --min-height: 40px;
    width: 160px;
    top: 65px;
    right: 15px;
  }
  .location-container {
    --min-height: 40px;
    width: 245px;
    top: 55px;
    right: 0;
  }
  .opacity-item {
    --min-height: 40px;
  }
  .opacity-item ion-range {
    --height: 36px;
  }
  .location-list {
    max-height: 250px;
    width: 221px;
    top: 50px;
    right: 12px;
  }
  .location-item {
    --min-height: 50px;
    font-size: 14px;
  }
  .globe-fab {
    top: 10px;
    left: 30px;
  }
  .windy-fab {
    top: 70px;
    right: 10px;
  }
  :host.no-center-fab .opacity-fab {
    right: 70px;
  }
  :host.no-center-fab .location-fab {
    right: 130px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/leaflet-map/leaflet-map.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,mBAAA;EACA,WAAA;EACA,iCAAA;EACA,iCAAA;EACA,gBAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAGE;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;AAAJ;;AAKE;EACE,iCAAA;AAFJ;;AAOA;;;;;;EAME,kBAAA;EACA,YAAA;AAJF;;AAOA;EACE,SAAA;EACA,WAAA;AAJF;;AAOA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2CAAA;EACA,YAAA;AAJF;;AAOA;EACE,6CAAA;AAJF;;AAOA;EACE,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,yCAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,sCAAA;EACA,0CAAA;AAJF;AAME;EACE,qCAAA;AAJJ;AAOE;EACE,4BAAA;EACA,iCAAA;AALJ;AAQE;EACE,0DAAA;AANJ;;AAWA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AARF;;AAWA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AARF;;AAWA;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;EACA,wBAAA;EACA,qBAAA;AARF;AAUE;EACE,aAAA;AARJ;;AAaE;EACE,iCAAA;EACA,eAAA;AAVJ;AAaE;EACE,iCAAA;AAXJ;;AAeA,kBAAA;AACA;EACE;IACE,YAAA;IACA,WAAA;EAZF;EAeA;IACE,4BAAA;IACA,8BAAA;EAbF;EAgBA;IACE,SAAA;IACA,WAAA;EAdF;EAiBA;IACE,SAAA;IACA,WAAA;EAfF;EAkBA;IACE,SAAA;IACA,YAAA;EAhBF;EAoBE;IAAe,WAAA;EAjBjB;EAkBE;IAAgB,WAAA;EAflB;EAkBA;IACE,SAAA;IACA,UAAA;EAhBF;EAmBA;IACE,SAAA;IACA,WAAA;EAjBF;EAoBA;IACE,kBAAA;IACA,YAAA;IACA,SAAA;IACA,WAAA;EAlBF;EAqBA;IACE,kBAAA;IACA,YAAA;IACA,SAAA;IACA,QAAA;EAnBF;EAsBA;IACE,kBAAA;EApBF;EAsBE;IACE,cAAA;EApBJ;EAwBA;IACE,iBAAA;IACA,YAAA;IACA,SAAA;IACA,WAAA;EAtBF;EAyBA;IACE,kBAAA;IACA,eAAA;EAvBF;AACF;AA2BA,mBAAA;AACA;EACE;IACE,YAAA;IACA,WAAA;EAzBF;EA4BA;IACE,4BAAA;IACA,8BAAA;EA1BF;EA6BA;IACE,SAAA;IACA,WAAA;EA3BF;EA8BA;IACE,SAAA;IACA,YAAA;EA5BF;EA+BA;IACE,SAAA;IACA,YAAA;EA7BF;EAiCE;IAAe,WAAA;EA9BjB;EA+BE;IAAgB,YAAA;EA5BlB;EA+BA;IACE,SAAA;IACA,UAAA;EA7BF;EAgCA;IACE,SAAA;IACA,WAAA;EA9BF;EAiCA;IACE,kBAAA;IACA,YAAA;IACA,SAAA;IACA,WAAA;EA/BF;EAkCA;IACE,kBAAA;IACA,YAAA;IACA,SAAA;IACA,QAAA;EAhCF;EAmCA;IACE,kBAAA;EAjCF;EAmCE;IACE,cAAA;EAjCJ;EAqCA;IACE,iBAAA;IACA,YAAA;IACA,SAAA;IACA,WAAA;EAnCF;EAsCA;IACE,kBAAA;IACA,eAAA;EApCF;AACF;AAwCA,kBAAA;AACA,kBAAA;AACA;EACE;IACE,YAAA;IACA,WAAA;EAtCF;EAyCA;IACE,4BAAA;IACA,8BAAA;EAvCF;EA0CA;IACE,SAAA;IACA,WAAA;EAxCF;EA2CA;IACE,SAAA;IACA,YAAA;EAzCF;EA4CA;IACE,SAAA;IACA,YAAA;EA1CF;EA6CA;IACE,kBAAA;IACA,YAAA;IACA,SAAA;IACA,WAAA;EA3CF;EA8CA;IACE,kBAAA;IACA,YAAA;IACA,SAAA;IACA,QAAA;EA5CF;EA+CA;IACE,kBAAA;EA7CF;EA+CE;IACE,cAAA;EA7CJ;EAiDA;IACE,iBAAA;IACA,YAAA;IACA,SAAA;IACA,WAAA;EA/CF;EAkDA;IACE,kBAAA;IACA,eAAA;EAhDF;EAmDA;IACE,SAAA;IACA,UAAA;EAjDF;EAoDA;IACE,SAAA;IACA,WAAA;EAlDF;EAsDE;IAAe,WAAA;EAnDjB;EAoDE;IAAgB,YAAA;EAjDlB;AACF","sourcesContent":[":host {\r\n  display: block;\r\n  height: 100%;\r\n  width: 100%;\r\n  position: relative;\r\n}\r\n\r\n.leaflet {\r\n  height: 100%;\r\n  width: 100%;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.custom-popup .leaflet-popup-content-wrapper {\r\n  background: #2c3e50;\r\n  color: #fff;\r\n  font-size: var(--font-size-small);\r\n  line-height: var(--spacing-large);\r\n  border-radius: 0;\r\n}\r\n\r\n.custom-popup .leaflet-popup-content-wrapper a {\r\n  color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.custom-popup .leaflet-popup-tip-container {\r\n  width: 30px;\r\n  height: 15px;\r\n}\r\n\r\n.custom-popup .leaflet-popup-tip {\r\n  background: transparent;\r\n  border: none;\r\n  box-shadow: none;\r\n}\r\n\r\n::ng-deep {\r\n  .leaflet-tooltip.track-tooltip {\r\n    width: 200px;\r\n    white-space: normal;\r\n    word-wrap: break-word;\r\n    line-height: 1.4;\r\n    padding: 6px 10px;\r\n  }\r\n}\r\n\r\nion-fab-button {\r\n  ion-icon {\r\n    font-size: var(--icon-size-small);\r\n  }\r\n}\r\n\r\n\r\n.map-layers-fab,\r\n.center-fab,\r\n.opacity-fab,\r\n.location-fab,\r\n.globe-fab,\r\n.windy-fab {\r\n  position: absolute;\r\n  z-index: 999;\r\n}\r\n\r\n.map-layers-fab {\r\n  top: 10px;\r\n  right: 10px;\r\n}\r\n\r\n.opacity-container {\r\n  position: absolute;\r\n  padding: 0;\r\n  margin: 0;\r\n  background-color: var(--color-primary-pale);\r\n  z-index: 999;\r\n}\r\n\r\n.icon-contrast {\r\n  color: var(--color-primary-contrast-contrast);\r\n}\r\n\r\n.opacity-item {\r\n  justify-content: space-around;\r\n  justify-items: center;\r\n  position: absolute;\r\n  border-radius: var(--border-radius-large);\r\n  z-index: 999;\r\n  opacity: 0.7;\r\n  width: 100%;\r\n  --padding-inline: var(--spacing-small);\r\n  --inner-padding-end: var(--spacing-medium);\r\n\r\n  &::part(native) {\r\n    --padding-start: var(--spacing-small);\r\n  }\r\n\r\n  ion-icon[slot='start'] {\r\n    margin: var(--spacing-small);\r\n    font-size: var(--icon-size-small);\r\n  }\r\n\r\n  ion-range {\r\n    padding-inline: var(--spacing-small) var(--spacing-medium);\r\n  }\r\n}\r\n\r\n\r\n.location-container {\r\n  position: absolute;\r\n  padding: 0;\r\n  margin: 0;\r\n  z-index: 999;\r\n}\r\n\r\n.location-searchbar {\r\n  z-index: 999;\r\n  --padding: 0;\r\n  --background: white;\r\n}\r\n\r\n.location-list {\r\n  position: absolute;\r\n  overflow-y: auto;\r\n  border-radius: 0 0 8px 8px;\r\n  z-index: 999;\r\n  -ms-overflow-style: none;\r\n  scrollbar-width: none;\r\n\r\n  &::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.location-item {\r\n  &:hover {\r\n    --background: rgba(0, 0, 0, 0.08);\r\n    cursor: pointer;\r\n  }\r\n\r\n  &:active {\r\n    --background: rgba(0, 0, 0, 0.12);\r\n  }\r\n}\r\n\r\n/* Small screens */\r\n@media (max-width: 599px) {\r\n  ion-fab-button {\r\n    height: 36px;\r\n    width: 36px;\r\n  }\r\n\r\n  app-map-layers-panel {\r\n    --map-panel-offset-top: 54px;\r\n    --map-panel-offset-right: 10px;\r\n  }\r\n\r\n  .center-fab {\r\n    top: 10px;\r\n    right: 50px;\r\n  }\r\n\r\n  .opacity-fab {\r\n    top: 10px;\r\n    right: 90px;\r\n  }\r\n\r\n  .location-fab {\r\n    top: 10px;\r\n    right: 130px;\r\n  }\r\n\r\n  :host.no-center-fab {\r\n    .opacity-fab { right: 50px; }\r\n    .location-fab { right: 90px; }\r\n  }\r\n\r\n  .globe-fab {\r\n    top: 10px;\r\n    left: 10px;\r\n  }\r\n\r\n  .windy-fab {\r\n    top: 50px;\r\n    right: 10px;\r\n  }\r\n\r\n  .opacity-container {\r\n    --min-height: 30px;\r\n    width: 116px;\r\n    top: 50px;\r\n    right: 12px;\r\n  }\r\n\r\n  .location-container {\r\n    --min-height: 30px;\r\n    width: 175px;\r\n    top: 35px;\r\n    right: 0;\r\n  }\r\n\r\n  .opacity-item {\r\n    --min-height: 30px;\r\n\r\n    ion-range {\r\n      --height: 30px;\r\n    }\r\n  }\r\n\r\n  .location-list {\r\n    max-height: 150px;\r\n    width: 151px;\r\n    top: 45px;\r\n    right: 12px;\r\n  }\r\n\r\n  .location-item {\r\n    --min-height: 30px;\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n\r\n/* Medium screens */\r\n@media (min-width: 600px) and (max-width: 1023px) {\r\n  ion-fab-button {\r\n    height: 44px;\r\n    width: 44px;\r\n  }\r\n\r\n  app-map-layers-panel {\r\n    --map-panel-offset-top: 62px;\r\n    --map-panel-offset-right: 10px;\r\n  }\r\n\r\n  .center-fab {\r\n    top: 10px;\r\n    right: 60px;\r\n  }\r\n\r\n  .opacity-fab {\r\n    top: 10px;\r\n    right: 110px;\r\n  }\r\n\r\n  .location-fab {\r\n    top: 10px;\r\n    right: 160px;\r\n  }\r\n\r\n  :host.no-center-fab {\r\n    .opacity-fab { right: 60px; }\r\n    .location-fab { right: 110px; }\r\n  }\r\n\r\n  .globe-fab {\r\n    top: 10px;\r\n    left: 10px;\r\n  }\r\n\r\n  .windy-fab {\r\n    top: 60px;\r\n    right: 10px;\r\n  }\r\n\r\n  .opacity-container {\r\n    --min-height: 36px;\r\n    width: 130px;\r\n    top: 60px;\r\n    right: 15px;\r\n  }\r\n\r\n  .location-container {\r\n    --min-height: 36px;\r\n    width: 215px;\r\n    top: 45px;\r\n    right: 0;\r\n  }\r\n\r\n  .opacity-item {\r\n    --min-height: 36px;\r\n\r\n    ion-range {\r\n      --height: 36px;\r\n    }\r\n  }\r\n\r\n  .location-list {\r\n    max-height: 200px;\r\n    width: 191px;\r\n    top: 48px;\r\n    right: 12px;\r\n  }\r\n\r\n  .location-item {\r\n    --min-height: 40px;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n\r\n/* Large screens */\r\n/* Large screens */\r\n@media (min-width: 1024px) {\r\n  ion-fab-button {\r\n    height: 50px;\r\n    width: 50px;\r\n  }\r\n\r\n  app-map-layers-panel {\r\n    --map-panel-offset-top: 68px;\r\n    --map-panel-offset-right: 10px;\r\n  }\r\n\r\n  .center-fab {\r\n    top: 10px;\r\n    right: 70px;\r\n  }\r\n\r\n  .opacity-fab {\r\n    top: 10px;\r\n    right: 130px;\r\n  }\r\n\r\n  .location-fab {\r\n    top: 10px;\r\n    right: 190px;\r\n  }\r\n\r\n  .opacity-container {\r\n    --min-height: 40px;\r\n    width: 160px;\r\n    top: 65px;\r\n    right: 15px;\r\n  }\r\n\r\n  .location-container {\r\n    --min-height: 40px;\r\n    width: 245px;\r\n    top: 55px;\r\n    right: 0;\r\n  }\r\n\r\n  .opacity-item {\r\n    --min-height: 40px;\r\n\r\n    ion-range {\r\n      --height: 36px;\r\n    }\r\n  }\r\n\r\n  .location-list {\r\n    max-height: 250px;\r\n    width: 221px;\r\n    top: 50px;\r\n    right: 12px;\r\n  }\r\n\r\n  .location-item {\r\n    --min-height: 50px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .globe-fab {\r\n    top: 10px;\r\n    left: 30px;\r\n  }\r\n\r\n  .windy-fab {\r\n    top: 70px;\r\n    right: 10px;\r\n  }\r\n\r\n  :host.no-center-fab {\r\n    .opacity-fab { right: 70px; }\r\n    .location-fab { right: 130px; }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
